// Module
var code = "<md-calendar ng-model=\"panel.date\" md-min-date=\"panel.minDate\" md-max-date=\"panel.maxDate\" md-date-filter=\"panel.dateFilter\"> </md-calendar> ";
// Exports
module.exports = code;